const Dashboard = () =>
  import(
    /* webpackChunkName: "dashboard.Dashboard" */ '@/views/private/Dashboard.vue'
  );
const Menu = () =>
  import(
    /* webpackChunkName: "dashboard.Dashboard" */ '@/views/private/Menu.vue'
  );

const Account = () =>
  import(
    /* webpackChunkName: "dashboard.Dashboard" */ '@/views/private/setting/Account.vue'
  );
const Profile = () =>
  import(
    /* webpackChunkName: "dashboard.Dashboard" */ '@/views/private/setting/Profile.vue'
  );
const ChangePassword = () =>
  import(
    /* webpackChunkName: "dashboard.Dashboard" */ '@/views/private/setting/ChangePassword.vue'
  );
const UnitIndex = () =>
  import(
    /* webpackChunkName: "dashboard.Dashboard" */ '@/views/private/farm/Index.vue'
  );
const UnitDetail = () =>
  import(
    /* webpackChunkName: "dashboard.Dashboard" */ '@/views/private/unit/Detail.vue'
  );
const EventIndex = () =>
  import(
    /* webpackChunkName: "dashboard.Dashboard" */ '@/views/private/event/Index.vue'
  );
const EventDetail = () =>
  import(
    /* webpackChunkName: "dashboard.Dashboard" */ '@/views/private/event/Detail.vue'
  );
const AnnouncementIndex = () =>
  import(
    /* webpackChunkName: "dashboard.Dashboard" */ '@/views/private/announcement/Index.vue'
  );
const UserIndex = () =>
  import(
    /* webpackChunkName: "dashboard.Dashboard" */ '@/views/private/user/Index.vue'
  );
const UserDetail = () =>
  import(
    /* webpackChunkName: "dashboard.Dashboard" */ '@/views/private/user/Detail.vue'
  );
const MeetingRoom = () =>
  import(
    /* webpackChunkName: "dashboard.Dashboard" */ '@/views/private/user/MeetingRoom.vue'
  );
const UserDetailLaporan = () =>
  import(
    /* webpackChunkName: "dashboard.Dashboard" */ '@/views/private/user/detail/Laporan.vue'
  );
const MonitoringMap = () =>
  import(
    /* webpackChunkName: "dashboard.Dashboard" */ '@/views/private/monitoring/Map.vue'
  );
const ReportIndex = () =>
  import(
    /* webpackChunkName: "dashboard.Dashboard" */ '@/views/private/report/Index.vue'
  );
const ReportDetail = () =>
  import(
    /* webpackChunkName: "dashboard.Dashboard" */ '@/views/private/report/Detail.vue'
  );
const routes = [
  {
    path: '/dashboard',
    name: 'dashboard',
    component: Dashboard,
    meta: {
      title: 'Dashboard'
    },
    roles: ['1', '2']
  },
  {
    path: '/menu',
    name: 'menu',
    component: Menu,
    meta: {
      title: 'Menu'
    },
    roles: ['1', '2']
  },
  {
    path: '/map',
    name: 'Map',
    component: MonitoringMap,
    meta: {
      title: 'Map'
    },
    roles: ['1', '2']
  },
  {
    path: '/wilayah',
    name: 'unit',
    component: UnitIndex,
    meta: {
      title: 'Master Data Wilayah'
    },
    roles: ['1', '2']
  },
  {
    path: '/wilayah/:id',
    name: 'unit-detail',
    component: UnitDetail,
    meta: {
      title: 'Detail Wilayah'
    },
    roles: ['1', '2']
  },
  {
    path: '/event',
    name: 'event',
    component: EventIndex,
    meta: {
      title: 'Master Data event'
    },
    roles: ['1', '2']
  },
  {
    path: '/event/:id',
    name: 'event-detail',
    component: EventDetail,
    meta: {
      title: 'Detail event'
    },
    roles: ['1', '2']
  },
  {
    path: '/call/:uid',
    name: 'Call',
    component: MeetingRoom,
    meta: {
      title: 'Meeting'
    },
    roles: ['1', '2', '3']
  },
  {
    path: '/report',
    name: 'report',
    component: ReportIndex,
    meta: {
      title: 'Laporan'
    },
    roles: ['1', '2', '3']
  },
  {
    path: '/report/detail/:id',
    name: 'report-detail',
    component: ReportDetail,
    meta: {
      title: 'Detail Laporan'
    },
    roles: ['1', '2', '3']
  },
  {
    path: '/user',
    name: 'user',
    component: UserIndex,
    meta: {
      title: 'Master Data Pengguna'
    },
    roles: ['1', '2', '3']
  },
  {
    path: '/user/detail/:id',
    component: UserDetail,
    roles: ['1', '2', '3'],
    meta: {
      title: 'Detail Pengguna'
    },
    children: [
      {
        path: 'laporan',
        name: 'user-laporan',
        component: UserDetailLaporan,
        meta: {
          title: 'Laporan Pengguna'
        },
        roles: ['1', '2', '3']
      }
    ]
  },
  {
    path: '/announcement',
    name: 'announcement',
    component: AnnouncementIndex,
    meta: {
      title: 'Pengumuman'
    },
    roles: ['1', '2']
  },
  {
    path: '/account',
    component: Account,
    roles: ['1', '2', '3'],
    meta: {
      title: 'Profil'
    },
    children: [
      {
        path: 'profile',
        name: 'account-profile',
        component: Profile,
        meta: {
          title: 'Profil Saya'
        },
        roles: ['1', '2', '3']
      },
      {
        path: 'password',
        name: 'account-password',
        component: ChangePassword,
        meta: {
          title: 'Ganti Password'
        },
        roles: ['1', '2', '3']
      }
    ]
  }
];

export default routes.map((route) => {
  const meta = {
    public: false,
    title: route.meta.title
  };
  return { ...route, meta };
});
